// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Omni Environments API
 * API to manage Omni Development Environments
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface ResponseEnvironmentCreated
 */
export interface ResponseEnvironmentCreated {
  /**
   *
   * @type {string}
   * @memberof ResponseEnvironmentCreated
   */
  id?: string;
  /**
   *
   * @type {number}
   * @memberof ResponseEnvironmentCreated
   */
  opId?: number;
}

/**
 * Check if a given object implements the ResponseEnvironmentCreated interface.
 */
export function instanceOfResponseEnvironmentCreated(
  value: object,
): value is ResponseEnvironmentCreated {
  return true;
}

export function ResponseEnvironmentCreatedFromJSON(
  json: any,
): ResponseEnvironmentCreated {
  return ResponseEnvironmentCreatedFromJSONTyped(json, false);
}

export function ResponseEnvironmentCreatedFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ResponseEnvironmentCreated {
  if (json == null) {
    return json;
  }
  return {
    id: json['id'] == null ? undefined : json['id'],
    opId: json['op_id'] == null ? undefined : json['op_id'],
  };
}

export function ResponseEnvironmentCreatedToJSON(
  json: any,
): ResponseEnvironmentCreated {
  return ResponseEnvironmentCreatedToJSONTyped(json, false);
}

export function ResponseEnvironmentCreatedToJSONTyped(
  value?: ResponseEnvironmentCreated | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    id: value['id'],
    op_id: value['opId'],
  };
}
